import React from 'react';

import SvgIcon from './SvgIcon';

const CloseFull = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M18.666 18.667L5.335 5.333m13.331.002L5.334 18.667 18.666 5.335z"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

CloseFull.displayName = 'CloseFullIcon';

export default CloseFull;
